/* src/app/admin-dashboard/inventory-details/inventory-details.component.css */
:host-context(.inv-inventory-details-root) {
  display: block;
  margin-top: 2.5rem;
}
.inv-result-col {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 1.5rem;
  min-width: 250px;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 1.5rem;
  font-family:
    "Roboto",
    "Helvetica Neue",
    sans-serif;
  flex: 1 1 300px;
}
.inv-result-col.inv-first-col {
  flex: 1 1 33%;
  max-width: 33%;
}
.inv-result-row {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  overflow-x: auto;
  justify-content: center;
}
.inv-endpoint-row {
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}
.inv-action-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 2.5rem;
  margin-bottom: 2.5rem;
}
.inv-action-col {
  flex: 1 1 600px;
  max-width: 700px;
  min-width: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.inv-action-response {
  width: 100%;
  margin-top: 1rem;
}
button,
.theme-button {
  background: var(--primary-color);
  color: #fff;
  border: none;
  padding: 0.6rem 2rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1.1rem;
  font-family:
    "Roboto",
    "Helvetica Neue",
    sans-serif;
  margin: 0.5rem 0;
  transition: background 0.2s, color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
}
button:disabled,
.theme-button:disabled {
  background: #bdbdbd;
  cursor: not-allowed;
}
.theme-button:active {
  animation-name: button-down;
  animation-duration: 1s;
}
.btn-success {
  background: var(--green) !important;
  color: #fff !important;
}
.btn-failure {
  background: var(--red) !important;
  color: #fff !important;
}
.inv-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 3px solid #fff;
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  animation: inv-spin 1s linear infinite;
  margin-left: 0.5rem;
}
.inv-spinner-large {
  width: 32px !important;
  height: 32px !important;
  border-width: 5px !important;
}
@keyframes inv-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
pre {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 1rem;
  font-size: 0.95rem;
  overflow-x: auto;
  max-width: 100%;
  font-family:
    "Roboto Mono",
    "Consolas",
    monospace;
}
.inv-result-col > div,
.inv-result-col > pre {
  margin-bottom: 0.5rem;
}
.inv-error-table {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 1rem;
  background: #fff;
  table-layout: auto;
}
.inv-error-table th,
.inv-error-table td {
  border: 1px solid #e0e0e0;
  padding: 0.5rem 1rem;
  text-align: left;
}
.inv-error-table th {
  background: #f5f5f5;
  font-weight: 600;
}
.inv-error-table tr:nth-child(even) {
  background: #fafafa;
}
/*# sourceMappingURL=inventory-details.component.css.map */
